import React from "react";
import { Tab, Nav, Dropdown } from "react-bootstrap";
import loadable from "@loadable/component";
import pMinDelay from "p-min-delay";
import RentStatisticChart from "../../components/charts/rechart/RentStatisticChart";

const _RentStatisticTab = ({ chartData }) => {
  return (
    <>
      <Tab.Container defaultActiveKey="Monthly">
        <div className="card">
          <div className="card-header border-0 flex-wrap">
            <h4 className="fs-20">Monthly Order Sales Report</h4>
          </div>
          <div className="card-body py-0">
            <Tab.Content>
              <Tab.Pane eventKey="Monthly">
                <div id="SalesStatistic" className="Sales">
                  <RentStatisticChart chartData={chartData} />
                </div>
              </Tab.Pane>
            </Tab.Content>
          </div>
        </div>
      </Tab.Container>
    </>
  );
};
export default _RentStatisticTab;
